/** Page title row with optional badge (e.g. counts, version) and right-aligned actions. */
export default function PageHeader({ title, badge, description, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 pt-1">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="text-2xl font-bold text-primary tracking-tight">{title}</h1>
          {badge}
        </div>
        {description && <p className="mt-1 text-sm text-on-surface-variant max-w-3xl">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
